export const LIST_DASHBOARD_DATA_REQUEST = "LIST_DASHBOARD_DATA_REQUEST"
export const LIST_DASHBOARD_DATA_SUCCESS = "LIST_DASHBOARD_DATA_SUCCESS"
export const LIST_DASHBOARD_DATA_FAIL = "LIST_DASHBOARD_DATA_FAIL"